<div id="wrap">
  <div class="preadesao">
    <h1>Esqueci minha senha</h1>
    @if (!concluido) {
      <p>Confirme os dados abaixo para recuperar seu acesso</p>
    }
    @if (!concluido) {
      <div class="box adesao">
        <form [formGroup]="form">
          <div class="form-group full-width">
            <input type="text" formControlName="cpf" mask="000.000.000-0" placeholder="CPF" />
            <span>Somente números</span>
          </div>
          <div class="form-group full-width">
            <input type="email" formControlName="email" placeholder="Email" />
            @if (!this.form.get('email').valid) {
              <div>
                @if (this.form.get('email').dirty) {
                  <div>
                    <small class="text-danger">
                      Email inválido
                    </small>
                  </div>
                }
              </div>
            }
          </div>
          <div class="text-danger text-center full-width erro-servidor" [ngStyle]="{'visibility': msgErro==null ? 'hidden' : 'visible' }">
            {{msgErro}}
          </div>
          <button type="submit" class="btn_verde" [disabled]="!form.valid || loading" (click)="enviar()">
            ENVIAR  @if (loading) {
            <i class="fas fa-spinner fa-spin"></i>
          }
        </button>
      </form>
    </div>
  }

  @if (concluido) {
    <div class="alert alert-success text-center" role="alert">
      Email enviado com sucesso
    </div>
  }
</div>
</div>